export default __webpack_public_path__ + "static/media/art.1c054088.png";